const constants = {
  PAGE_SIZE: 20,
  IMAGE_BASEURL:'https://image.acheter-acheter.com'
}

const ConstantsPlugin = {
  install(Vue) {
    Vue.prototype.$constants = constants
  }
}

export default ConstantsPlugin
export { constants }